import { render, staticRenderFns } from "./BusinessItem.vue?vue&type=template&id=6b9fe16d&scoped=true"
import script from "./BusinessItem.vue?vue&type=script&lang=js"
export * from "./BusinessItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9fe16d",
  null
  
)

export default component.exports